export enum NotificationType {
    Success = <any>'Success',
    Error = <any>'Error',
    Info = <any>'Info',
    Warning = <any>'Warning',
    Fatal = <any>'Fatal'
}